export default __webpack_public_path__ + "static/media/donate.7cac3a3e.gif";